// extracted by mini-css-extract-plugin
module.exports = {"fixedWrapper":"UpsellModalContent_fixedWrapper__QEYg8","modalWrapper":"UpsellModalContent_modalWrapper__4aI1l","contentWrapper":"UpsellModalContent_contentWrapper___nr35"};